import React from "react";
export default function MobileCapture() {
  return (
    <>
      <section className="mobile-capture-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <h2 className="heading center-heading">Capture Anywhere. Access Instantly. Stay Secure.</h2>
              <p className="sub-heading">With Dox and Box, your business information is always within reach. From capturing documents in the field to accessing critical data on the go, our platform ensures seamless workflows without boundaries.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mobile-capture-box">
                <img src="/assets/images/mobile-capture-box-1.webp" alt="Mobile Capture Image" />
                <span>Sales Teams in the Field</span>
                <p>Access customer documents, quotes, proposals, contracts, invoices, instantly, whether you're at a client site or on the move. Stay prepared and responsive at every stage of the sales process.</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mobile-capture-box">
                <img src="/assets/images/mobile-capture-box-2.webp" alt="Mobile Capture Image" />
                <span>Managers on the Go</span>
                <p>Review contracts, HR documents, financial reports, presentations from any device. Make decisions, approve workflows, stay connected, no matter where you are.</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mobile-capture-box">
                <img src="/assets/images/mobile-capture-box-3.webp" alt="Mobile Capture Image" />
                <span>Remote & Hybrid Teams</span>
                <p>Eliminate dependency on slow VPNs and scattered systems. Enable teams to securely access, share, manage documents from a centralized platform, boosting productivity and collaboration.</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mobile-capture-box">
                <img src="/assets/images/mobile-capture-box-4.webp" alt="Mobile Capture Image" />
                <span>Distributed Offices</span>
                <p>Ensure seamless information flow across multiple locations. With cloud-enabled access and real-time workflows, teams can collaborate efficiently and stay aligned, regardless of geography.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}